import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button, Tooltip } from 'reactstrap'
import styles from './WidgetSlatePlugin.scss'
import { widgetTypes, widgets, hasWidget, hasWidgetByType, onClickButton } from './WidgetSlatePluginContainer'

class WidgetButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
    this.onClicks = {}
    widgetTypes.map(styleType => {
      this.onClicks[styleType] = this.onWidget.bind(this, styleType)
    })
  }

  onWidget (widgetType, e) {
    return this.props.onChange(onClickButton(e, this.props.state, widgetType))
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState } = this.props
    const isActive = hasWidget(editorState)

    const buttonStyles = {
    }

    return (
      <Button
        id={'WidgetButton' + this.uid}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.WidgetButton}
      > More
        {
          process.env.NODE_ENV !== 'test' &&
          <Tooltip className={styles.WidgetTooltip} placement='top' isOpen={this.state.tooltipOpen} target={'WidgetButton' + this.uid} toggle={this.toggle} autohide={false}>
            <ButtonGroup vertical style={{margin: '8px'}}>
              {widgetTypes.map(type =>
                type !== 'Widget'
                ? <Button key={type}
                  style={buttonStyles[type]}
                  color={hasWidgetByType(editorState, type) ? 'primary' : 'secondary'}
                  onClick={this.onClicks[type]}>{widgets[type].title}
                </Button>
                : null
              )}
            </ButtonGroup>
          </Tooltip>
        }
      </Button>
    )
  }
}

WidgetButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default WidgetButton



// WEBPACK FOOTER //
// ./src/components/WidgetSlatePlugin/WidgetButton.js